import { Route } from 'src/routes/Route'

export const LeaderBoardRoute = Route({ path: '/leader-boards' })

export type LeaderBoardRoute = Route<typeof LeaderBoardRoute>
